const NotificationTypesEnum = Object.freeze({
  LABOR: 'LABOR',
  CONTRACT: 'CONTRACT',
  BOTH_LABOR_AND_CONTRACT: 'BOTH_LABOR_AND_CONTRACT',
  LABOR_DUAL: 'LABOR_DUAL',
  LABOR_BC_SUBSTANTIATION: 'LABOR_BC_SUBSTANTIATION',
  LABOR_PROJECT_SUBSTANTIATION: 'LABOR_PROJECT_SUBSTANTIATION',
});

export default NotificationTypesEnum;
